"use client";

import React from "react";
import { useDebounce } from 'use-debounce';
interface Category {
  id: string | number;
  label: string;
  labelEn: string;
}

interface SearchProps {
  categories: Category[];
  lang: "fr" | "en";
  libeleLabel: string;
  catLabel: string;
  onChangeCategory: Function;
  onChangeSearch?: Function;
}

const Search: React.FC<SearchProps> = ({
  categories,
  lang,
  libeleLabel,
  catLabel,
  onChangeCategory,
  onChangeSearch,
}) => {

  const placeholder =
    lang === "fr"
      ? "Exemple : Réfrigérateur combiné"
      : "Example: Combined refrigerator";
  const categoryAll =
    lang === "fr" ? "Toutes les catégories" : "All categories";
    

  const handleChangeCategory = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChangeCategory) {
      onChangeCategory(e);
    }
  };

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChangeSearch) {
      onChangeSearch(e);
    }
  };

  return (
    <div className="m-search">
      <div className="m-search__box">
        <form>
          <div className="m-search__wrapper">
            <div className="m-search__item m-search__item--field">
              <label className="m-label">{libeleLabel}</label>
              <input
                type="text"
                className="m-input"
                name="query"
                placeholder={placeholder}
                onChange={handleChangeSearch}
              />
            </div>

            <div className="m-search__item m-search__item--cat">
              <label className="m-label">{catLabel}</label>
              <div className="m-select">
                <select name="category" onChange={handleChangeCategory}>
                  <option value="">{categoryAll}</option>
                  {categories.map((x) => {
                    const label = lang === "fr" ? x.label : x.labelEn;
                    return (
                      <option key={x.id} value={x.id}>
                        {label}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            {/* 
            <div className="m-search__button">
              <button type="submit" className="m-button m-button--blue">
                <span className="m-button__icon icon-search"></span>
              </button>
            </div>
            */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Search;
